import * as lexicalHelpers from 'modules/Lexical/helpers';
import * as Models from 'models';

type UpdateExistingProjectMetadataTokensArgs =
  Models.GetProjectDataProcessArgs
  | Models.RefreshProcessArgs;

export function updateExistingProjectMetadataTokens<T extends UpdateExistingProjectMetadataTokensArgs>(
  args: T,
): T {
  const {
    assets: {
      documents,
    },
  } = args;

  args.assets.documents = lexicalHelpers.updateProjectMetadataTokens(
    documents,
    args.assets.rootDocument,
  );

  return args;
}
